module.exports = __webpack_public_path__ + "img/housebox.3cc0cf13.svg";